/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon64Regular = forwardRef('ArrowDUturnUpLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M28 3.382a1.5 1.5 0 1 1 2 2.236L14.332 19.637a2.524 2.524 0 0 0-.334.363H35.5C46.27 20 55 28.73 55 39.5S46.27 59 35.5 59h-15a1.5 1.5 0 0 1 0-3h15C44.613 56 52 48.613 52 39.5S44.613 23 35.5 23H13.998c.097.13.209.25.334.363L30 37.383a1.5 1.5 0 1 1-2 2.235l-15.668-14.02a5.5 5.5 0 0 1 0-8.197L28 3.382Z" })));
});
